import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { isEmpty } from 'lodash';

import clsx from 'clsx';

import BobPage from '../../../components/BobPage';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Navigation from '../Navigation/Navigation';
import ManageClientPage from './Client/ManageClientPage';
import ManageSitePage from './Site/ManageSitePage';
import ManageEquipmentPage from './Equipment/ManageEquipmentPage';
import ManageSystemPage from './System/ManageSystemPage';

import * as classes from './EntitiesPage.module.css';

const EntityManagePage = ({
    history,
    ...props
}) => {
    const [view, setView] = useState('');
    const [isCreate, setIsCreate] = useState(true);
    const [returnUrl, setReturnUrl] = useState('');

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        if (history.location.search && history.location.state && history.location.state.returnUrl) {
            setReturnUrl(history.location.state.returnUrl);
        }
    }, []);

    useEffect(() => {
        setView(queryValues.entityType);
    }, [queryValues.entityType]);

    useEffect(() => {
        if (queryValues.entityId) setIsCreate(false);
    }, [queryValues.entityId]);

    const renderView = () => {
        switch (view) {
            case 'client':
                return <ManageClientPage />;
            case 'site':
                return <ManageSitePage />;
            case 'equipment':
                return <ManageEquipmentPage />;
            case 'system':
                return <ManageSystemPage />;
            default:
                return;
        }
    };

    const handleRoute = () => {
        const path = '/v2/dashboard/core/entities';

        if (returnUrl) {
            history.push(returnUrl);
        } else {
            history.push({ pathname: path, search: history.location.search });
        }
    };

    const renderTitle = () => {
        const updatedView = view.split('');
        if (!isEmpty(updatedView)) {
            updatedView[0] = updatedView[0].toUpperCase();
        }
        updatedView.join();

        if (isCreate) {
            return (
                <div>
                    <span onClick={() => handleRoute()} role="none" className={clsx('material-icons-outlined', classes.Icon)}>
                        chevron_left
                    </span>
                    <span>Add New {updatedView}</span>
                </div>
            );
        } else {
            return (
                <div>
                    <span onClick={() => handleRoute()} role="none" className={clsx('material-icons-outlined', classes.Icon)}>
                        chevron_left
                    </span>
                    <span>Edit {updatedView}</span>
                </div>
            );
        }
    };

    if (!view) return null;

    return (
        <BobPage>
            <div className={classes.CompanyPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <Navigation />
                    </div>
                </div>
                <div className={classes.TitlePanel}>
                    {renderTitle()}
                </div>
                <div className={classes.TablePanel}>
                    {renderView()}
                </div>
            </div>
        </BobPage>
    );
};

export default withRouter(connect(null, null)(EntityManagePage));
